<template>
    <div>
        
        <a-modal
        title="Warning"
        :visible="visible"
        @ok="commitChanges"
        :confirmLoading="saveChangesSpinner"
        @cancel="handleCancel"
        >
            All changes to be made cannot be reverted. Are you sure you want to proceed?
        </a-modal>

        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <div class="container-fluid mt--7">
        <div v-if="errorMessage != null" id="errorNotification">
            <base-alert type="danger">
                <span class="alert-inner--text"> {{errorMessage}}</span> <br>
            </base-alert>
        </div>
            <div class="row">
                <div class="col-md-12" style="color: white;"><a @click.prevent="backToPXWithValue()"><span class="fa fa-arrow-left" style="padding-bottom: 5px; color: white;"/></a>&nbsp;&nbsp; BACK TO PRODUCT SELECTION </div>
                <br><br>
            </div>
            <div class="card mb-3">
                <div class="row no-gutters">   
                    <div class="col-md-7" style="padding: 15px; padding-left: 25px; height: 65vh; overflow-y: scroll;">
                        <div class="row">
                            <div class="col-md-8">
                                <h1>Products for Mass Updating</h1>
                            </div>
                            <div class="col-md-4">
                                <small class="float-right" style="padding-top: 15px;">{{this.productList.length}} products selected </small>
                            </div>
                        </div>
                        <!-- <div class="col-md-12"> -->
                            <!-- <a-table :columns="columns" :dataSource="data" :scroll="scroll" :loading="loading" :rowKey="record => record.id" :pagination="pagination" @change="handleTableChange"> -->
                            <a-table :columns="columns" :dataSource="productList" :pagination="pagination" :rowKey="record => record.id" :key="productListKey" :loading="loading" :expandRowByClick="true">
                                <template slot="action" slot-scope="action">
                                  <center>
                                      <div class="table-button-container">
                                        <button class="btn btn-default btn-sm" style="background-color: #8B8B8B; border-color: #8B8B8B;" @click.prevent="updateProductList(action)">Remove</button>
                                      </div>
                                  </center>
                                </template>
                            </a-table>
                        <!-- </div> -->
                    </div>
                    <div class="col-md-5 mass-update">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mass-update-header">
                                    SELECT UPDATE OPTIONS
                                </div>
                            </div>
                            <div class="col-md-12">
                                <!-- :formSettings="formSettings" @valueUpdated="updateSettings" -->
                                <a-spin :spinning="spinning">
                                    <dynamic-form :convertedJson="convertedJson" :key="componentKey" @valueUpdated="updateSettings"></dynamic-form>
                                </a-spin>
                                <!-- <hr>
                                {{this.formSettings}} -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-7">
                    <base-button type="default" style="background-color: #394A5D;" @click.prevent="backToPX">Cancel Update</base-button>
                    <a-popconfirm title="You are about to clear all options set. Are you sure you want to proceed?" @confirm="clearOptions" okText="Yes" cancelText="No">
                        <base-button type="outline-default" style="border-color: #394A5D; color: #394A5D" >Clear Options</base-button>
                    </a-popconfirm>

                    <!-- <base-button type="outline-default" style="border-color: #394A5D; color: #394A5D">Reset to Original</base-button> -->
                </div>
                <div class="col-md-5">
                    <base-button :disabled="productList.length == 0" class="float-right" type="primary" style="width: 30%; background-color: #2371CC; border-color: #2371CC;" @click.prevent="visible = true">Finish</base-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'

    var ObjGen = require('../../../node_modules/objgen/objgen.js').ObjGen;

    const table_columns = [
      { title: 'Description',  dataIndex: 'name', key: 'name'},
      { title: 'Barcode',  dataIndex: 'barcode', key: 'barcode'},
      { title: 'Stock No',  dataIndex: 'stock_no', key: 'stock_no'},
      { title: 'Grade Level',  dataIndex: 'product_grade_level', key: 'grade_level'},
      { title: 'Group',  dataIndex: 'product_group["name"]', key: 'product_group_name'},      
      { title: '', key: 'operation', scopedSlots: { customRender: 'action' },},
    ];

    export default {
        components: {
          DynamicForm,
        },
        data: function(){
            return {
                spinning: false,
                loading: true,
                productList: [],
                pagination: false,
                columns: table_columns,
                jsonField: null,
                convertedJson: null,
                componentKey: 0,
                formSettings: {},
                tableParams: {},
                filterParams: {},
                tags: [],
                visible: false,
                productListKey: 0,
                saveChangesSpinner: false,
                errorMessage:null,
                previousDiscountValues: {}
            }
        },
        computed: {
            ...mapState(['endPoint', 'serverType']),
        },
        created: async function() {
            this.productListKey++;
        },
        mounted: async function() {            
            
            this.tableParams = this.$attrs.tableParams
            this.filterParams = this.$attrs.filterParams
            this.tags = this.$attrs.tags

            const loadProductList = () => {
                return new Promise(resolve => {
                    setTimeout(() => resolve(
                        this.productList =  this.$attrs.productList
                    ), 2000)
                })
            }

            await loadProductList()
            
            if(this.productList == undefined){
                this.productList = secureStorage.getItem("productList")
            } 
            
            this.spinning = true
            var jsonField;
            secureStorage.setItem("productList", this.productList)
            jsonField = await HTTPRequest.getRequest(this.endPoint + 'dynamic_forms/MassUpdate?field_name=profile_name' , null, null)   
            this.convertedJson = ObjGen.xJson(jsonField.template, {numSpaces: 2})
            this.componentKey++;
            this.$notification['info']({
                message: 'Note',
                description: "Select update options by checking the boxes"
            });

            if(this.productList.length >= 1){
                this.loading = false
            }
            this.spinning = false
            this.productListKey++
        },
        methods: {
            backToPX(){
                this.$router.push("products_v2")
                secureStorage.removeItem("productList")
            },
            backToPXWithValue(){
                this.productListKey++
                this.$router.push({
                    name: 'product explorer',
                    params: {
                        productList: this.productList,
                        tableParams: this.tableParams,
                        massUpdateMode: true,
                        filterParams: this.filterParams,
                        tags: this.tags
                    }
                })
            },
            clearOptions(){
                this.formSettings = {}
                this.componentKey++
            },
            handleCancel(){
                this.visible = false
            },
            updateProductList(product){
                // console.log(product)
                // var indexValue = this.productList.indexOf(product.id)
                // console.log(indexValue)
                // console.log(this.productList)
                // this.productList
                // new method on deleting
                let productList = [...this.productList]
                var indexValue = this.productList.indexOf(product)
                // console.log(indexValue)
                if(indexValue >= 0){
                    productList.splice(indexValue,1)
                }else{
                    productList.forEach(function(obj) {
                        // console.log(product.id)
                        if(obj.children != null){
                            // var childindex = obj.children.indexOf(product)
                            obj.children = obj.children.filter(s => s.id != product.id);
                            // console.log(childindex)
                        }
                    });
                }
                this.productList = productList
            },
            updateSettings(formSettings){
                this.applyNoLimitAutoFlags(formSettings)
                this.formSettings = formSettings
            },
            applyNoLimitAutoFlags(formSettings){
                this.applyNoLimitAutoFlag(formSettings, "sc_discount_percent", "is_senior_nolimit")
                this.applyNoLimitAutoFlag(formSettings, "pwd_discount_percent", "is_pwd_nolimit")
                this.applyNoLimitAutoFlag(formSettings, "pnstm_discount_percent", "is_pnstm_nolimit")
            },
            applyNoLimitAutoFlag(formSettings, discountKey, nolimitKey){
                if(formSettings["override_" + discountKey] != true){
                    this.$delete(this.previousDiscountValues, discountKey)
                    return
                }

                var discountValue = formSettings[discountKey]
                if(this.previousDiscountValues[discountKey] === discountValue){
                    return
                }

                this.$set(this.previousDiscountValues, discountKey, discountValue)
                var discount = Number(discountValue)
                if(isNaN(discount)){
                    return
                }

                var normalizedDiscount = discount >= 1 ? discount / 100 : discount
                var autoValue = normalizedDiscount >= 0.2

                formSettings[this.getNoLimitOverrideKey(nolimitKey)] = autoValue
                formSettings[nolimitKey] = autoValue
            },
            applyDiscountFlagsForSubmit(formSettings){
                this.applyDiscountFlagForSubmit(formSettings, "sc_discount_percent", "is_senior_vatex", "is_senior_nolimit")
                this.applyDiscountFlagForSubmit(formSettings, "pwd_discount_percent", "is_pwd_vatex", "is_pwd_nolimit")
                this.applyDiscountFlagForSubmit(formSettings, "pnstm_discount_percent", "is_pnstm_vatex", "is_pnstm_nolimit")
            },
            applyDiscountFlagForSubmit(formSettings, discountKey, vatexKey, nolimitKey){
                if(formSettings["override_" + discountKey] != true){
                    return
                }

                var discount = Number(formSettings[discountKey])
                if(isNaN(discount)){
                    return
                }

                var normalizedDiscount = discount >= 1 ? discount / 100 : discount
                var autoValue = normalizedDiscount >= 0.2

                formSettings["override_" + vatexKey] = true
                formSettings[vatexKey] = autoValue
                formSettings[this.getNoLimitOverrideKey(nolimitKey)] = true
                formSettings[nolimitKey] = autoValue
            },
            getNoLimitOverrideKey(nolimitKey){
                return "override_" + nolimitKey.replace("nolimit", "no_limit")
            },
            async commitChanges(){
                this.saveChangesSpinner = true
                // console.log(this.formSettings)
                var matrix_id = []
                this.productList.forEach(val => {
                    if(val.children != null){
                        matrix_id.push(val.children.map(function(v){
                                return v.id
                            })
                        )
                    }
                })

                var parent_ids = this.productList.map(function(value) {
                    return value.id;
                    // console.log(value.id)
                });

                // merge and flatten ids
                parent_ids.push(matrix_id)
                var ids = parent_ids.flat(Infinity)

                // remove duplicate id
                ids.filter((item, index) => {
                    return ids.indexOf(item) === index
                })

                var formSettings = Object.assign({}, this.formSettings)
                this.applyDiscountFlagsForSubmit(formSettings)

                var jsonBody = {ids: ids, formSettings: formSettings}
                var response = await HTTPRequest.postRequest(this.endPoint + 'products/mass_update_products' , null, jsonBody)   

                if(response["error"] == undefined){
                    this.$notification['warning']({
                        message: 'Ongoing Mass Update',
                        description: `Click 'View Jobs' to review.. Click 'View Jobs' to review process.`,
                        btn: h => {
                            return h(
                            'base-button',
                            {
                                props: {
                                type: 'primary',
                                class: 'btn-sm',
                                },
                                on: {
                                click: () => this.$router.push("/jobs"),
                                },
                            },
                            'View Jobs',
                            );
                        },
                    });
                    this.$router.replace("/products_v2")
                }else {
                    this.errorMessage = response["error"].split(",")
                }
                this.saveChangesSpinner = false
                this.visible = false
            }
        }
    }

</script>

<style>
    .mass-update{
        border-left: 1px solid #e0e0e0;
        background-color: #F8F9FE;
        height: 65vh;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .mass-update-header {
        font-family: Open Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 14px;
        /* identical to box height */
        height: 60px;
        display: flex;
        align-items: center;
        padding: 15px;
        color: #717F9B;
        border-bottom: 1px solid #C0C8D9;
    }

   

</style>
